import React, { ReactNode } from 'react'

interface AdminBaseModalProps {
  isOpen: boolean
  onClose: () => void
  title?: string
  children: ReactNode
  maxWidth?: string
  showCloseButton?: boolean
  overlayOpacity?: string
}

const AdminBaseModal: React.FC<AdminBaseModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = 'max-w-[360px]',
  showCloseButton = true,
  overlayOpacity = 'bg-opacity-30',
}) => {
  if (!isOpen) return null

  return (
    <>
      {/* 오버레이 */}
      <div
        className={`fixed inset-0 bg-black ${overlayOpacity} z-50`}
        onClick={onClose}
      />

      {/* 모달 컨테이너 */}
      <div className="fixed inset-0 z-50 flex items-center justify-center px-16px">
        <div
          className={`
            w-full
            ${maxWidth}
            bg-white
            rounded-16px
            shadow-lg
            max-h-[calc(100vh-48px)]
            overflow-y-auto
            overflow-x-visible
            scrollbar-hide
            flex
            flex-col
          `}
          onClick={(e) => e.stopPropagation()}
        >
          {/* 헤더 */}
          {(title || showCloseButton) && (
            <div className="flex items-center justify-between p-20px border-b border-brandPrimary-5%">
              {title && (
                <h3 className="text-style-title2 text-textColorText2">
                  {title}
                </h3>
              )}
              {showCloseButton && (
                <button
                  onClick={onClose}
                  className={`
                    w-32px
                    h-32px
                    flex
                    items-center
                    justify-center
                    rounded-8px
                    hover:bg-backgroundColorBg2
                    transition-colors
                    text-textColorText2
                    text-style-title3
                    ${title ? '' : 'ml-auto'}
                  `}
                >
                  ×
                </button>
              )}
            </div>
          )}

          {/* 컨텐츠 */}
          <div className="flex-1 overflow-visible">{children}</div>
        </div>
      </div>
    </>
  )
}

export default AdminBaseModal
